<template>
    <section id="faq" class="faq-area" v-if="faqData.length">

        <div class="dd-bubbles">
            <img class="bubble slow" src="../../../public/img/all-effect-img/Bog-Blob.svg" id="blue-side-bubble-11" alt="b">
        </div>

        <div class="container">
            <div class="row faq-wrapper">
                <div class="col-12 col-sm-12 col-md-5" v-if="pageData.image_name">
                    <div class="faq-img-box">
                        <img :src="`${file_path}/${pageData.image_name}`" :alt="pageData.page_heading">
                    </div>
                </div>
            
                <div class="col-12 col-sm-12 col-md-7" :class="(pageData.image_name) ? 'col-md-7' : 'col-md-12'">
                    <div class="section-title-area">
                        <h2 class="section-heading text-center">{{ pageData.page_heading }}</h2>
                    </div>
                    <FAQList :faqData="faqData" />
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import FAQList from "./List"

export default {
    components: {
        FAQList
    },
    data(){
        return {
            faqData: [],
            pageData: [],
            file_path: ''
        }
    },
    methods: {
        async getData(){     
            let params = {
                'show_home':'Y'
            }          
            this.$http.get(`/faq`, {
                params: {params}
            }).then(res=>{                       
                if(res.status === 200 && res.data){                    
                    if(res.data.page_data)
                        this.pageData = res.data.page_data
                    if(res.data.result)
                        this.faqData = res.data.result
                    if(res.data.page_file_path)
                        this.file_path = res.data.page_file_path
                }
            })
        }
    },
    created: function(){
        this.getData()
    }
}
</script>